import { changeWordingForWC } from "../../../../../lib/misc";
import { formatCurrency } from "../../../../../lib/script";
import PracticeDrawerSectionRow from "./PracticeDrawerSectionRow";

export default function PracticeDrawerSection({classes, activeCase, drawerData = {}, column}) {
    const row = drawerData ?? {}
    const practices = Array.isArray(row.practices) ? row.practices : []

    const totals = practices.reduce((acc, item) => {
        const balance = Number(item?.balance) || 0
        const totalCharges = Number(item?.total_charges) || 0

        return {
            totalPracticeBalance: acc.totalPracticeBalance + balance,
            totalCharges: acc.totalCharges + totalCharges,
        }
    }, {
        totalPracticeBalance: 0,
        totalCharges: 0,
    })

    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <table>
            <thead>
                <tr>
                    <th>Practice</th>
                    <th>{changeWordingForWC(activeCase, 'HIPAA', 'WC-207')}</th>
                    <th>LOP</th>
                    <th>Location</th>
                    <th>Chart Number</th>
                    <th>Initial Treat. Date</th>
                    <th>Practice Status</th>
                    <th>Total Charges</th>
                    <th>Balance</th>
                    <th>Records sent via</th>
                    <th>Neg. Amt.</th>
                    {/* <th>Neg. Date</th>
                    <th>Neg. Time</th> */}
                    <th>Paid</th>
                    <th>Settlement Date</th>
                </tr>
            </thead>
            <tbody>
                {practices.map(item => (
                    <PracticeDrawerSectionRow key={item.id} item={item} />
                ))}     
       
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={7}><strong>Totals</strong></td>
                    <td><strong>${formatCurrency(totals.totalCharges)}</strong></td>
                    <td><strong>${formatCurrency(totals.totalPracticeBalance)}</strong></td>
                    <td colSpan={4}></td>
                </tr>
            </tfoot>
        </table>
    </div>
}